import { createContentPropTypes } from '../../helpers/content';

export const authorisedModalContent = {
	authorisedModalTitle: 'Authorised',
	authorisedModalBody: 'Your payment has been successfully authorised.',
	authorisedModalOkButton: 'Ok',
};

export const contentPropTypes = createContentPropTypes(authorisedModalContent);
